import axios from 'axios'
// @ts-ignore
import LocaleService from './services/locale_service'

interface ILocation {
  locale: string
  name?: string
  abbr?: string
  bounds?: {
    bottom: number
    left: number
    right: number
    top: number
  }
}

const locationStorageKey = 'location'

let locationPromise: Promise<ILocation>

function getLocationByIP() {
  if (locationPromise) {
    return locationPromise
  }

  locationPromise = axios.get<ILocation>('/WAS/country_by_ip').then(({ data }) => {
    saveLocation(data)
    return data
  })

  return locationPromise
}

function getLocationFromStore() {
  const storageData = localStorage.getItem(locationStorageKey)
  return storageData && JSON.parse(storageData)
}

export function saveLocation(data: ILocation) {
  localStorage.setItem(locationStorageKey, JSON.stringify(data))
}

export async function getCurrentLocation() {
  return getLocationFromStore() || getLocationByIP()
}

export async function autoSwitchLocale() {
  const location = await getCurrentLocation()
  LocaleService.autoSwitchToLocale(location.locale)
}
